export const constants = {
  '@context': 'https://schema.org',
  address: {
    '@type':'PostalAddress',
    streetAddress: '125 Summer St',
    addressLocality: 'Boston',
    addressRegion: 'MA',
    postalCode: '02111',
    addressCountry: 'USA',
  },
  awards: [
    'The Boston Globe’s 2021 Best Places to Work',
    'Deloitte’s 2021 Technology Fast 500 list',
    'Built In Boston’s 100 Best Places to Work',
    '50 Companies with the Best Benefits and Best Large Companies to Work For in Boston lists',
  ],
  brand: 'Klaviyo',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: ' 1-800-338-1744',
    contactType: 'sales',
  },
  description: 'Klaviyo is a marketing automation platform for email marketing services, SMS, and more. It is a tool or software that functions like a CDP and gives your brand direct ownership of your digital data and interactions—so you can build long-term customer relationships at scale, and grow your business on your own terms.',
  founders: [
    {
      '@type': 'Person',
      name: 'Andrew Bialecki',
    },
  ],
  foundingDate: 2012,
  legalName: 'Klaviyo, Inc.',
  logo: 'https://www.klaviyo.com/icons/icon-512x512.png',
  numberOfEmployees: 1548,
  sameAs: [
    'https://www.wikidata.org/wiki/Q106631196',
    'https://www.facebook.com/klaviyo/',
    'https://www.twitter.com/klaviyo',
    'https://en.wikipedia.org/wiki/Klaviyo',
    'https://www.instagram.com/klaviyo/',
    'https://www.youtube.com/user/Klaviyo',
    'https://careers.klaviyo.com/',
    'https://academy.klaviyo.com/',
    'https://help.klaviyo.com/hc/en-us',
    'https://developers.klaviyo.com/en',
    'https://www.linkedin.com/company/klaviyo',
    'clavio',
    'klavyo',
    'Klayvio',
    'klavio',
    'klavyio',
    'kvyo',
  ],
  url: 'https://www.klaviyo.com',
};
